function setUnapprovedUsers({ input, state }) {
  const addresstypes = state.get('client.addresstypes')

  const result = input.result.map(user => {
    const { clients } = user
    return {
      ...user,
      modules: clients.modules
        ? clients.modules.map(module => {
            return module.module
          })
        : null,
      companies: addresstypes.map(type => {
        if (clients[type] && clients[type].company) {
          return clients[type].company
        }
        return null
      })
    }
  })
  state.set('users.unapproved', result)
}

export default setUnapprovedUsers



// WEBPACK FOOTER //
// ./src/modules/app/actions/setUnapprovedUsers.js